/**
 * Free Indian PIN-code lookup service.
 *
 * Endpoint:
 * https://api.postalpincode.in/pincode/{PINCODE}
 *
 * No API key is required. The response contains postal-office,
 * district/state/country information for the supplied PIN.
 */
const postalApi = {
  async getByPincode(pincode) {
    const cleanPin = String(pincode || "")
      .replace(/\D/g, "")
      .slice(0, 6);

    if (cleanPin.length !== 6) {
      throw new Error("Pincode must contain exactly 6 digits");
    }

    try {
      const response = await fetch(
        `https://api.postalpincode.in/pincode/${cleanPin}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error(
          `Pincode API returned ${response.status}: ${response.statusText}`
        );
      }

      const payload = await response.json();
      const data = Array.isArray(payload) ? payload[0] : payload;

      // Extract city from post office data - prefer Head Post Office or match with District
      const postOffice = data?.PostOffice || [];
      const headOffice = postOffice.find(po => po.BranchType === "Head Post Office");
      const city = headOffice?.Name || postOffice[0]?.District || postOffice[0]?.City || "";

      return {
        success: data?.Status === "Success",
        message: data?.Message || "",
        city: city,
        district: postOffice[0]?.District || "",
        state: postOffice[0]?.State || "",
        country: postOffice[0]?.Country || "India",
        pincode: cleanPin,
      };
    } catch (error) {
      console.error("Postal API Error:", error);
      throw error;
    }
  },
};

export default postalApi;
